import React, {useContext, useEffect, useState} from 'react';
import BootstrapAccordion from "react-bootstrap/Accordion";
import {FaClipboardCheck, FaLaptopHouse} from "react-icons/fa";
import Calculator from "./calculator/Calculator";
import ApplicationMenu from "./ApplicationMenu";
import ScheduleAppointment from "./ScheduleAppointment";
import {SectionsContext} from "../../contexts/SectionsProvider";
import {Link} from "react-router-dom";
import Alerts from "./Alerts";

function Sidebar2(props) {
    const context = useContext(SectionsContext)
    // const applySectionsNows = context.sections.filter(section => {
    //     return section.stage === 'APPLY'
    // }).map(section => {
    //     return {
    //         now: sectionNow(section)
    //     }
    // })
    // console.warn('apply section now')
    // const sum = applySectionsNows.map(item => {
    //     return item.now
    // }).reduce((partialSum, a) => partialSum + a, 0);
    // const total = Math.round( (sum / applySectionsNows.length) )
    const [state,setState] = useState({overlay:false,openPanels: ["1"]})
    const setOverlay = (overlay)=>{
        setState({...state, overlay: overlay})
    }
    const handleOnSelect = (i)=>{
        setState({...state,openPanels: i})
    }
    return (
        <div>
            <Alerts/>
            <Link to="/apply/setup"  onClick={()=>{props.sidebar.close()}} className="w-100 d-flex justify-content-between align-items-center text-bodyColor">
                <div className="pe-2">
                    <h5 className="mb-0">Tweak your mortgage</h5>
                    <small className="text-black-50 d-block py-1" style={{fontSize:'0.8rem'}}>Adjust your mortgage requirements and calculate your monthly payment</small>
                </div>

                <FaLaptopHouse className="ms-auto flex-shrink-0 me-3" size={80}/>
            </Link>
            <hr className="mb-0"/>
            <BootstrapAccordion  onSelect={handleOnSelect}
                // key={key}
                // {...extraAttr}
                // defaultActiveKey={defaultActive}
                className={'sidebar-accordion menu-accordion'}>
            <BootstrapAccordion.Item eventKey="0">
                <BootstrapAccordion.Header>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="pe-2">
                            <h5 className="mb-0">Complete your application</h5>
                            <small className="text-black-50 d-block pt-1" style={{fontSize:'0.8rem'}}>Follow the steps to apply for your mortgage</small>
                        </div>

                        <FaClipboardCheck className="ms-auto flex-shrink-0" size={70}/>
                    </div>
                </BootstrapAccordion.Header>
                <BootstrapAccordion.Body className="p-0 pt-3">
                    <ApplicationMenu opened={state.openPanels} sidebar={props.sidebar}/>
                </BootstrapAccordion.Body>
            </BootstrapAccordion.Item>
        </BootstrapAccordion>
            <ScheduleAppointment/>
        </div>
    );
}

export default Sidebar2;